export default "__VITE_PUBLIC_ASSET__5e91f05d__"